import React from 'react';
import PropTypes from 'prop-types';
import copy from 'clipboard-copy';

import useToast from '../../../hooks/useToast';
import { FormType } from '../../../Model/Form';

import {
  Container,
  ActionButton,
} from './styles';
import texts from './texts.json';

const ActionContainer = ({
  row,
  navigateToForm,
  handleFormDuplicateClick,
  handleFormArchiveClick,
  handleSetDefaultClick,
  defaultFormIdByCoachId,
}) => {
  const { showToast } = useToast();

  const copyFormEmbedCode = (coachId, formId) => {
    // Create the HTML string to be inserted to webflow
    const htmlString = `<div id="form" data-coachId="${coachId}" data-formId="${formId}"></div>`;
    copy(htmlString);
    showToast(texts.copied);
  };

  return (
    <Container>
      <ActionButton
        disabled={row.isDefault}
        onClick={() => navigateToForm(row.id)}
      >
        {texts.edit}
      </ActionButton>
      <ActionButton onClick={() => handleFormDuplicateClick(row.id)}>
        {texts.duplicate}
      </ActionButton>
      {row.type === FormType.LEAD && (
        <ActionButton onClick={() => copyFormEmbedCode(row.coachId, row.id)}>
          {texts.copy}
        </ActionButton>
      )}
      {row.type === FormType.POST_PAYMENT && !row.isDefault && !row.isArchived && (
        <ActionButton
          disabled={defaultFormIdByCoachId[row.coachId] === row.id}
          onClick={() => handleSetDefaultClick(row.id)}
        >
          {texts.setDefault}
        </ActionButton>
      )}
      <ActionButton
        disabled={row.isDefault}
        onClick={() => handleFormArchiveClick(row.id)}
      >
        {row.isArchived ? texts.unarchive : texts.archive}
      </ActionButton>
    </Container>

  );
};

ActionContainer.propTypes = {
  row: PropTypes.object.isRequired,
  navigateToForm: PropTypes.func.isRequired,
  handleFormDuplicateClick: PropTypes.func.isRequired,
  handleFormArchiveClick: PropTypes.func.isRequired,
  handleSetDefaultClick: PropTypes.func.isRequired,
  defaultFormIdByCoachId: PropTypes.object,
};

ActionContainer.defaultProps = {
  defaultFormIdByCoachId: {},
};

export default ActionContainer;
